export class FukushimaMinpoService {
    async logout() {
        // /epaper/fukushimaLogout.json
        try {
            const url = "https://viewer-api.minpo.jp/epaper/fukushimaLogout.json";
            let authToken = this.getToken();
            let payload = {
                thirduid: authToken.thirduid,
                authtoken: authToken.token
            };
            // payload to url parameter string
            let params = Object.keys(payload).map(function (key) {
                return encodeURIComponent(key) + '=' + encodeURIComponent(payload[key]);
            });
            let paramsStr = params.join('&');
            let a = fetch(url + "?" + paramsStr, {
                method: "GET"
            });
            let response = await a;
            let json = await response.json();
            let status = json["resultstatus"];
            if (status == "1") {
                this.removeToken();
                location.href = "/epaper/";
                return true;
            }
            else {
                location.href = "/epaper/";
                return false;
            }
        }
        catch (e) {
            console.log(e);
            //false to promise
            location.href = "/epaper/";
            console.log(e);
            return new Promise((resolve, reject) => {
                resolve(false);
            });
        }
    }
    async login(account, password) {
        const url = "https://viewer-api.minpo.jp/epaper/authenticate.json";
        let urlencodedPasswd = encodeURIComponent(password);
        let urlencodedAccount = encodeURIComponent(account);
        let payload = {
            password: urlencodedPasswd,
            account: urlencodedAccount,
            osver: "1",
            devmodel: "1",
            devtime: "1",
            appver: "1.0.0",
            devid: "1",
            reqtoken: "1",
            pkg: "jp.fukushimaminpo.viewer.pc",
            authtype: "40",
            buildno: "1"
        };
        // payload to url parameter string
        let params = Object.keys(payload).map(function (key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(payload[key]);
        });
        let paramsStr = params.join('&');
        let a = fetch(url + "?" + paramsStr, {
            method: "GET",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        });
        let response = await a;
        let json = await response.json();
        return json;
    }
    redirectToApp() {
        let token = this.getToken();
        if (token !== undefined && token != null && token.token != "") {
            // pkg=jp.fukushimaminpo.viewer.pc&mcd=MINPO_FAHM&npd=20221224&uid=A230200002_00001&tkn=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJmdWt1c2hpbWFtaW5wbyUyQnMlNDBlcGFwZXIuanAiLCJ1c2VyTm8iOiJBMjMwMjAwMDAyIiwiYWNjb3VudE5vIjoiMDAwMDEiLCJ0b2tlbiI6InRFWlNnTzVVa3ZPMHVBSUJvR3VCeWJRYlU0VU5jYlpyYWF0aXVlUFYifQ.HjoLtupn=1&&chiiki=no
            // tokenで params内のuidとtokenを 上書きする
            let params = window.location.search;
            let urlParams = new URLSearchParams(params);
            urlParams.set('uid', token.thirduid);
            urlParams.set('tkn', token.token);
            window.location.href = 'https://viewer-data.minpo.jp/hv/index_viewer.html?' + urlParams.toString();
            return;
        }
        else {
            return;
        }
    }
    parseErrorMessage(json) {
        switch (json.resultstatus) {
            case '-999':
                return '同時接続数制限が上限を超えています。しばらくしてから再度お試しください。';
            case '-10':
                return '電子メールアドレスまたはパスワードに誤りがあります';
            case '-511':
                return '認証サーバのパラメータエラーです';
            case '-1':
                return 'パラメータエラーです';
        }
        return '';
    }
    getToken() {
        // get token from cookie
        let token = "";
        let thirduid = "";
        let cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];
            if (cookie.indexOf("nts_token") >= 0) {
                token = cookie.split('=')[1];
            }
            if (cookie.indexOf("nts_uid") >= 0) {
                thirduid = cookie.split('=')[1];
            }
        }
        if (token == "" || thirduid == "") {
            token = sessionStorage.getItem("nts_token");
            thirduid = sessionStorage.getItem("nts_uid");
            if (this.isExpireSessionStorage()) {
                return null;
            }
        }
        return { token: token, thirduid: thirduid };
    }
    isExpireSessionStorage() {
        const expireString = sessionStorage.getItem('nts_expire');
        if (expireString) {
            // sessionStorageに有効期限が保存されている場合
            const expire = new Date(expireString);
            const now = new Date();
            if (expire > now) {
                // 有効期限が現在時刻より後の場合
                return false;
            }
            else {
                // 有効期限が現在時刻より前の場合
                return true;
            }
        }
        else {
            // sessionStorageに有効期限が保存されていない場合
            return true;
        }
    }
    removeToken() {
        let expire = new Date();
        expire.setHours(expire.getHours() - 2);
        document.cookie = "nts_token=; expires=" + expire.toUTCString() + "; domain=minpo.jp; path=/";
        document.cookie = "nts_uid=; expires=" + expire.toUTCString() + "; domain=minpo.jp; path=/";
        // remove to locastorage
        sessionStorage.removeItem("nts_token");
        sessionStorage.removeItem("nts_uid");
        sessionStorage.removeItem("nts_expire");
    }
    storeToken(json) {
        // {"uag":"Buffer(jp.fukushimaminpo.viewer.and)-Buffer(1.0.0)-Buffer(1)","resultstatus":"1","userid":"A230200002_00001","servertime":"1678173261064","authtoken":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJmdWt1c2hpbWFtaW5wbyUyYnNAZXBhcGVyLmpwIiwidXNlck5vIjoiQTIzMDIwMDAwMiIsImFjY291bnRObyI6IjAwMDAxIiwidG9rZW4iOiJyd3E0akFPV1ExSGZMRmhxZ3JtQlhnbzZneENaNDg2VnJ2QmxhQ2ZrIn0.GWoQVYijxu78Mof_mqVBUaoAUxIBpoVyZQG3oS_WOXk","reqtoken":"1","thirduid":"A230200002_00001","authexpiretime":"1678176861000"}
        let token = json.authtoken;
        let thirduid = json.userid;
        // store to cookie expire is 2 hour lator
        let expire = new Date();
        expire.setHours(expire.getHours() + 2);
        // domain cookie domain is minpo.jp
        document.cookie = "nts_token=" + token + "; expires=" + expire.toUTCString() + "; domain=minpo.jp; path=/";
        document.cookie = "nts_uid=" + thirduid + "; expires=" + expire.toUTCString() + "; domain=minpo.jp; path=/";
        // store to locastorage
        sessionStorage.setItem("nts_token", token);
        sessionStorage.setItem("nts_uid", thirduid);
        sessionStorage.setItem("nts_expire", expire.toUTCString());
    }
}
